module.exports = __webpack_public_path__ + "img/AL12X1-2.27376c2e.png";